import axios from "axios";
import Toast from "cogo-toast";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { USER_RESET } from "../reducers/user";
import { config } from './index'

export const instance = axios.create({
    baseURL: config.backend.apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    }
});
export const instanceENIGOOTurnikety = axios.create({
    baseURL: config.backend.enigooTurnstileUrl,
    headers: {
        'Content-Type': 'application/json',
    }
});

instanceENIGOOTurnikety.interceptors.request.use((cfg) => {
    const token = instance.defaults.headers.common["authorization"];
    if (token) cfg.headers["authorization"] = token;
    return cfg;
});

instance.interceptors.response.use(undefined, function (error) {
    if (error?.response?.status === 401) {
        localStorage.removeItem("authorization-leg-enigoo");
        Toast.success("Došlo k odhlášení. Prosím přihlašte se znovu.");

        let dispatch = useDispatch();
        dispatch({ type: USER_RESET });
        let navigate = useNavigate();
        navigate("/login");
    }

    return Promise.reject(error);
});

export const onErrorFunction = (error) => {

    if(error?.response?.data?.error){
        return error?.response?.data?.error
    }else if(error?.response?.data){
        return error.response.data
    }else{
        return {type: null, message: null, data: null}
    }
}

export const onSuccessFunction = (data)=>{
    if(data?.result && data.data){
        return data.data;
    }
}


